/**
 * Whether `key` is `entry`'s key, or begins with its prefix (a key ending in `*`).
 *
 * Apart from the register (`storeRegister.ts`) because the owner rule needs it
 * at sign-in and the register's text has no place in the launch entry (T-0688).
 */
export function entryCovers(entry: { readonly key: string }, key: string): boolean {
  return entry.key.endsWith('*') ? key.startsWith(entry.key.slice(0, -1)) : key === entry.key;
}
